<script setup lang="ts">
import useCommonLabels from "~/composables/useCommonLabels";
import useMagnoliaContext from "~/composables/useMagnoliaContext";
import { replacePattern } from "~/utils/helper/string";

export interface CommonLabelProps {
  forceEditMode?: boolean;
  path: string;
  placeholder?: string;
  tag?: string;
}

const { forceEditMode, path, placeholder, tag } = defineProps<CommonLabelProps>();

const { marketSetupLinks } = useMarketSetup();
const { isMagnoliaEdit } = useMagnoliaContext();

const isEditMode = computed(() => isMagnoliaEdit?.value || forceEditMode);

const { getLabelByPath, isLabelDefaultLabel } = useCommonLabels();
const onEditClick = () => {
  let message = `Path: ${path}`;
  if (placeholder) {
    message += `\nPlaceholder: ${JSON.stringify(placeholder)}`;
  }
  alert(message);
};

const rawLabel = path ? getLabelByPath(path ?? "") : "";
const isDefaultLabel = isLabelDefaultLabel(rawLabel, path);

const commonLabel = computed(() => replacePattern(rawLabel, placeholder, marketSetupLinks.value));
const containsHtml = commonLabel?.value && commonLabel?.value?.includes?.("data-html");
</script>

<template>
  <component
    :is="tag ?? 'span'"
    :id="isEditMode ? `common-label-${path}` : null"
    :class="[
      isEditMode && {
        'underline decoration-wavy': isEditMode,
        'decoration-dark-blue': !isDefaultLabel,
        'decoration-signal-red': !!isDefaultLabel,
      },
    ]"
    class="common-label"
    @click="isEditMode && onEditClick()"
  >
    <span v-if="containsHtml" v-html="commonLabel"></span>
    <span v-else-if="commonLabel">{{ commonLabel }}</span>
  </component>
</template>
